import { useTranslation } from "react-i18next";

import React from 'react';
import styled from 'styled-components';
import './style.scss';

const LoaderOverlayWrapper = styled.div`
  width: 100%;
  background-color: #ffffff94;
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const LoaderOverlay :React.FC = () => {
    const { t } = useTranslation();

    return (
        <LoaderOverlayWrapper>
            <div className="d-flex justify-content-center" style={{ paddingTop: '50px', paddingBottom: '50px' }}>
                <div className="spinner-border text-primary" style={{width: '5rem', height: '5rem'}} role="status">
                    <span className="visually-hidden">{ t("loading_tag_plain") }</span>
                </div>
            </div>
        </LoaderOverlayWrapper>
    )
};

export default LoaderOverlay;